import WebService from "../WebService";

const VideoEvents = {
  gets(params) {
    return WebService.get("/videos?" + params);
  },
  get(video_id, params) {
    return WebService.get(
      "/videos/" + video_id +'?'+ params
      //  +'&'+ target+'_id='+target_id
    );
  },
  update(video_id,data) {
    return WebService.post("/videos/" + video_id, data);
  },
  create(data) {
    return WebService.post("/videos", data);
  }
};

export default VideoEvents;
